<template>
  <div>
    <div class="desktop">
      <div class="reload">
        Обновите страницу
      </div>
    </div>
    <div class="fulfillment">
      <router-link to="/fulfillment">
        <img
          class="logo-text"
          src="../assets/greysislogotext.svg"
          alt="Greysis Logo Text"
        />
      </router-link>
      <menu-icon></menu-icon>

      <div class="topImg"></div>

      <wrap
        title="Call-Centre"
        pTag="Наш сall-centre создан специально для обработки заказов интернет-
магазинов. Наши операторы специально продают, а не обрабатывают заказы как роботы"
      ></wrap>

      <div class="go-down"></div>

      <div class="moreInfo">
        <h1 class="info">Информация</h1>
        <div class="grid-cover">
          <div class="grid-info">
            <div class="item item1" id="item1">
              <div class="itemOnePicture itemPicture"></div>
              <p>Высокая квалификация операторов</p>
            </div>
            <div class="item item2" id="item2">
              <div class="itemTwoPicture itemPicture"></div>
              <p>Запись всех разговоров и полная отчетность</p>
            </div>
            <div class="item item3" id="item3">
              <div class="itemThreePicture itemPicture"></div>
              <p>
                Консультируем на русском, узбекском и таджикском
              </p>
            </div>
            <div class="item item4" id="item4">
              <div class="itemFourPicture itemPicture"></div>
              <p>Первый вызов совершается в течении 15 минут с момента оформления заказа</p>
            </div>
          </div>
        </div>
      </div>

      <div class="distorted-text">
        <div class="distorted-img"></div>
        <div class="bg-grid"></div>
        <div class="dis-te">
          <h2>Call-center</h2>
          <h4>
             подразделение 
в компании, которое направлено на  обработку входящих и исходящих вызовов
          </h4>
        </div>
      </div>

      <div class="morePages">
        <h1 class="info">
          Вам так же будет <br />
          интересно:
        </h1>
        <div class="more-cover">
          <div class="more-info">
            <div class="more-item more-item2">
              <div class="more-decr">
                <h1>Fullfilment</h1>
                <div class="cover"></div>
                <h6>Обработка заказов интернет-магазинов</h6>
              </div>
              <router-link to="/fulfillment"
                ><div class="angle enter">Перейти</div></router-link
              >
            </div>
            <div class="more-item more-item3">
              <div class="more-decr">
                <h1>Консалтинг</h1>
                <div class="cover"></div>
                <h6>
                  На любой ваш вопрос в электронной коммерции у нас уже есть
                  ответы
                </h6>
              </div>
              <router-link to="/consulting"
                ><div class="angle enter">Перейти</div></router-link
              >
            </div>
            <div class="more-item more-item4">
              <div class="more-decr">
                <h1>Инвесторам</h1>
                <div class="cover"></div>
                <h6>
                  Вы крупный поставщик или импортёр продукции широкого спроса,
                  который хочет продавать онлайн?
                </h6>
              </div>
              <router-link to="/investors"
                ><div class="angle enter">Перейти</div></router-link
              >
            </div>
          </div>
        </div>
      </div>

      <div class="contact">
        <h1 class="info contact-title" id="see-grey">
          Обратиться в <br />
          Greysis:
        </h1>

        <router-link to="/contactmobile">
          <div class="angle enter contact-mobile">Контакты</div>
        </router-link>
      </div>

      <music></music>
      <footerWrap></footerWrap>
    </div>
  </div>
</template>

<script>
import { TimelineMax, gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
import $ from 'jquery'

import music from "../components/audio.vue";
import menuIcon from "../components/menuMobile.vue";
import wrap from "../components/wrapper.vue";
import footerWrap from "../components/footer.vue";

export default {
  name: "call-center",
  components: {
    music,
    menuIcon,
    footerWrap,
    wrap,
  },
  methods: {
    hey: function() {
      gsap.registerPlugin(CSSPlugin);
      $("html, body").animate({ scrollTop: 0 }, "slow");

      var cover = new TimelineMax();

      cover.set(".wrapper", { overflow: "hidden" });
      cover.set(".cover", { width: "0%" });
      cover.set(".title", { alpha: 0 });
      cover.set(".wrapper p", { translateY: "100vh" });
      cover.set("#go-lower", { translateY: "100vh" });
      cover.to(".cover", 1, { delay: 1, width: "100%" });
      cover.to(".title", 0.1, { alpha: 1 });
      cover.to(".cover", 1, { width: "10px", right: "unset", left: 0 });
      cover.to(".wrapper p, #go-lower", 1, { translateY: "0px" });
      cover.set(".wrapper", { overflow: "visible" });
      var width = new TimelineMax();
      width.to(".timer", 4, { delay: 1, width: "50vw" });
      width.to(".timer", 0.5, { opacity: 0 });

      $('.go-down').click(function() {
        $("html, body").animate({ scrollTop: window.innerHeight }, "slow");
      })
    },
  },
  mounted() {
    if (this.$route.name == "call-center") {
      this.hey();
    }
  }
};
</script>

<style scoped>


.desktop {
  display: block;
}

.fulfillment {
  display: none;
}
.reload {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.reload a {
  text-decoration: underline;
  opacity: 0.7;
}

  .go-down {
    display: none;
  }

@media only screen and (max-width: 900px) {
  .go-down {
    width: 40px;
    height: 40px;
    background-image: url("../assets/arrow.svg");
    background-size: contain;
    transform: rotate(-90deg);
    margin: 20px auto;
    display: block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%) rotate(-90deg);
    bottom: 10px;
    z-index: 20;
  }

.contact
{
  width: 80vw;
  margin-left: 10vw;
  margin-bottom: 50px;
}

.contact-title
{
  margin-bottom: 30px;
}

.contact .angle
{
  margin-left: 20px;
}

.cover
{
  height: 30px;
  position: absolute;
  background-color: #2778F3;
  top: 0;
  right: 0;
}
  .more-item {
    margin-bottom: 50px;
  }

  .angle {
    font-size: calc(1vw + 0.9vh + 0.6vmin);
    width: 50%;
    background-color: #2778f3;
    margin-top: 10px;
    padding: 7.5px;
  }

  .more-decr h1 {
    font-size: 1.4rem;
    margin-left: 20px;
  }

  .more-decr h6 {
    margin-top: 10px;
    font-weight: 100;
    font-size: 0.9em;
    padding-right: 20px;
    line-height: 23px;
    margin-left: 20px;
  }

  .more-cover {
    height: 100%;
    margin-top: 50px;
  }

  .more-info {
    display: grid;
    grid-template-columns: 1fr;
  }

  .more-info .angle
  {
    margin-left: 20px;
  }

  .more-info .more-item {
    position: relative;
  }

  .morePages {
    margin-top: 50px;
    margin-left: 10vw;
    width: 80%;
  }

  .distorted-text {
    height: 600px;
    position: relative;
  }

  .dis-te {
    position: relative;
    left: 10%;
    bottom: 10%;
    width: 80%;
    z-index: 1;
  }

  .dis-te h2,
  .dis-te h4 {
    font-weight: 100;
  }

  .dis-te h2 {
    font-size: 2em;
    border-bottom: #2778f3 3px solid;
    display: inline-block;
    margin-bottom: 15px;
  }

  .dis-te h4 {
    line-height: 26px;
  }

  .distorted-img {
    background-size: cover;
    height: 60%;
    width: 100vw;
    position: absolute;
    top: 35%;
    left: 0%;
    transform: translateY(-50%) scale(1);
    background-image: url("../assets/call-dis.png");
    background-position: 75% center;
    transition: 0.3s;
  }

  .bg-grid {
    height: 70%;
    background-image: url("../assets/grid.png");
    background-size: cover;
    position: relative;
    pointer-events: none;
    margin-top: 50px;
  }

  .fulfillment {
    display: block;
  }

  .desktop {
    display: none;
  }

  .moreInfo {
    margin-left: 10vw;
    margin-top: 50px;
  }

  .info {
    font-size: 1.6rem;
    font-weight: 100;
  }

  .grid-info {
    display: grid;
    grid-template-columns: 1fr;
  }

  .grid-info .item {
    height: 175px;
    transform: translateY(0%);
  }

  .grid-cover {
    width: calc(100vw - 10vw - 20px);
  }

  .item {
    position: relative;
  }

  .grid-info .item p {
    width: 90%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .itemPicture {
    height: 100%;
    width: 30%;
    background-position: right 60%;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
  }

  .itemOnePicture {
    background-image: url("../assets/callOneMob.svg");
  }

  .itemTwoPicture {
    background-image: url("../assets/callTwoMob.svg");
  }

  .itemThreePicture {
    background-image: url("../assets/callThreeMob.svg");
  }

  .itemFourPicture {
    background-image: url("../assets/callFourMob.svg");
  }

  .topImg {
    height: 50vh;
    width: 100vw;
    background-image: url("../assets/more-ful.png");
    background-position: 70% 50%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .logo-text {
    width: 30vw;
    position: absolute;
    top: 20px;
    left: 20px;
  }

  .nav {
    position: absolute;
    left: 20vw;
    top: 30px;
    display: none;
  }

  .nav li {
    font-size: calc(0.6vw + 0.5vh + 0.5vmin);
    display: inline-block;
    padding: 0 15px;
    color: #dedede;
    cursor: pointer;
    transition: 0.3s;
  }

  .nav li:hover {
    color: white;
  }

  .contacts {
    padding: 0 30px 5px 30px !important;
    margin-left: 20px;
    border-bottom: 2px solid #2778f3;
    text-transform: capitalize;
  }

  #container {
    position: absolute;
    top: 0;
    overflow: hidden;
    outline: 0;
  }

  canvas:focus,
  #container:focus {
    outline: 0;
  }

  @keyframes alpha {
    0% {
      opacity: 0;
    }

    90% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
}
</style>
